import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// utils
import { isServiceAdmin } from '../../../utils/permissions';

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import { getRecordTerm } from '../../../services/TermsService'
import FormService from '../../../services/FormService'
import ReportService from '../../../services/ReportService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import DataTable from '../../../components/simple/dataTable/DataTable.js';
import Text from '../../../components/simple/text/Text'
import Anchor from '../../../components/simple/anchor/Anchor.js';
import ActionButton from '../../../components/compound/actionButton/ActionButton.js';


// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import moment from 'moment'
import PulseLoader from 'react-spinners/PulseLoader.js'

function Plans (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [sort, setSort] = useState({
      property: 'reference',
      direction: 'desc'
    })

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')
    const params = useParams()
    const userId = params.userid

    const goBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        (async () => {
            if (!userId) { return }


            await getData()


            // setClickerValues(previousValues => ({
            // ...previousValues,
            // student: userId
            // }))

        })()
    }, [userId])

    const getData = async () => {
      setLoading(true)

      let searchType = 'incidentSearch'
      if (isServiceAdmin()) {
        searchType = 'globalIncidentSearch'
      }

      const results = await ReportService.getReport(
        apiToken,
        {
          orgId: activeOrg.id,
          // limit: 100,
          // page: 1
        },
        {
          submissionType: 'behaviourplan',
          query: [
            {
            "key": "studentName",
              "operator": "is",
              "response": userId,
              "relation": null
            }
          ],
          reports: [
            searchType
          ],
        },
      )

      if (results?.incidentSearch) {
        setData(results.incidentSearch)
      }

      setLoading(false)
    }



      const deleteReport = async submissionId => {
        if (window.confirm('Are you sure you want to delete this?')) {
          await FormService.updateSubmission(apiToken, submissionId, {
            status: 'Archived',
          });
          getData()
        }
      };

     const resultColumns = [
       {
         property: 'reference',
         header: <Text pad='none' margin='none' color='secondary' weight='800'>{getRecordTerm(terms, 'smartPlanBuilderTerm', 'Plan')} No</Text>,
         render: datum => (
           <Anchor onClick={e => {
              e.preventDefault();
              navigate(`/pdfviewer?url=${encodeURIComponent(datum.pdfUrl)}`);
            }} color='primary'>
             <Text>{datum.id ? `besmart-${datum.reference}` : ''}</Text>
           </Anchor>
         ),
       },
       {
         property: 'createdAt',
         header: <Text pad='none' margin='none' color='secondary' weight='800'>{getRecordTerm(terms, 'smartPlanBuilderTerm', 'Plan')} Date</Text>,
         render: datum => (
           <Text>
             {moment(datum.createdAt).format('DD/MM/YY') === 'Invalid date'
               ? 'No Date'
               : moment(datum.createdAt).format('DD/MM/YY')}
           </Text>
         ),
       },
       {
         property: 'flag',
         header: <Text pad='none' margin='none' color='secondary' weight='800'>Flag</Text>,
         render: datum => {
           const setColour = async color => {
             await FormService.updateSubmission(apiToken, datum.id, {
               flag: color,
             });

             Array.from(
               document.getElementsByClassName(`flag-${datum.id}`),
             ).forEach(function (element, index, array) {
               element.style.opacity = 0.15;
             });

             document.getElementById(
               `flag-${datum.id}-${color}`,
             ).style.opacity = 1;
           };

           return (
             <Box direction="row" width="100%">
               <ActionButton plain onClick={() => setColour('none')}>
                 <FontAwesomeIcon
                   id={`flag-${datum.id}-none`}
                   className={`flag-${datum.id}`}
                   icon={['fa', 'flag']}
                   color="#777"
                   plain
                   style={
                     !['red', 'green', 'yellow'].includes(datum.flag)
                       ? { margin: '1px', opacity: 1 }
                       : { margin: '1px', opacity: 0.15 }
                   }
                 />
               </ActionButton>
               <ActionButton plain onClick={() => setColour('green')}>
                 <FontAwesomeIcon
                   id={`flag-${datum.id}-green`}
                   className={`flag-${datum.id}`}
                   icon={['fa', 'flag']}
                   color="#00FF00"
                   plain
                   style={
                     'green' === datum.flag
                       ? { margin: '1px', opacity: 1 }
                       : { margin: '1px', opacity: 0.15 }
                   }
                 />
               </ActionButton>
               <ActionButton plain onClick={() => setColour('yellow')}>
                 <FontAwesomeIcon
                   id={`flag-${datum.id}-yellow`}
                   className={`flag-${datum.id}`}
                   icon={['fa', 'flag']}
                   color="#FFA500"
                   plain
                   style={
                     'yellow' === datum.flag
                       ? { margin: '1px', opacity: 1 }
                       : { margin: '1px', opacity: 0.15 }
                   }
                 />
               </ActionButton>
               <ActionButton plain onClick={() => setColour('red')}>
                 <FontAwesomeIcon
                   id={`flag-${datum.id}-red`}
                   className={`flag-${datum.id}`}
                   icon={['fa', 'flag']}
                   color="#FF0000"
                   plain
                   style={
                     'red' === datum.flag
                       ? { margin: '1px', opacity: 1 }
                       : { margin: '1px', opacity: 0.15 }
                   }
                 />
               </ActionButton>
             </Box>
           );
         },
       },
       {
         property: 'actions',
         header: <Text pad='none' margin='none' color='secondary' weight='800'>Actions</Text>,
         render: datum => (
           <>
             <Box direction="row" width="100%">
               {props?.type !== 'smartplan' && (
                 <ActionButton
                   onClick={() => {
                     navigate(`/incident/${datum.userId}/edit/${datum.id}`);
                   }}
                   target="_self"
                   plain
                   children={
                     <Box pad="5px">
                       <FontAwesomeIcon icon={['fal', 'edit']} color="#ff8300" />
                     </Box>
                   }
                 />
               )}

               {datum.pdfUrl && (
                 <>
                   <ActionButton
                     target="_blank"
                     plain
                     href={datum.pdfUrl}
                     children={
                       <Box pad="5px">
                         <FontAwesomeIcon
                           icon={['fal', 'download']}
                           color="#ff8300"
                         />
                         {/* <Download color='primary' size='medium' disabled /> */}
                       </Box>
                     }
                   />
                   <ActionButton
                     target="_blank"
                     plain
                     onClick={() => {
                       deleteReport(datum.id);
                     }}
                     children={
                       <Box pad="5px">
                         <FontAwesomeIcon
                           icon={['fal', 'trash']}
                           color="#ff8300"
                         />
                       </Box>
                     }
                   />
                 </>
               )}
             </Box>
           </>
         ),
       },
     ];



  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Divider color='primary' />
      <Box
        gap='small'
        round='small'
      >
        <DataTable
              columns={resultColumns}
              data={data}
              border={{ color: '#ddd' }}
              primaryKey="id"
              step={250}
              paginate={true}
              sort={sort}
              onSort={setSort}
            />
            {!data.length && <Text>There are no results to display.</Text>}
      </Box>
    </Box>
  )
}
export default Plans
